import { render, staticRenderFns } from "./zhuanjia.vue?vue&type=template&id=13ecc88f&scoped=true&"
import script from "./zhuanjia.vue?vue&type=script&lang=js&"
export * from "./zhuanjia.vue?vue&type=script&lang=js&"
import style0 from "./zhuanjia.vue?vue&type=style&index=0&id=13ecc88f&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ecc88f",
  null
  
)

export default component.exports